import { SingleValueCookie } from 'saddlebag-cookie';

import type { Nullable } from '@shared/types/utils';

import { X_GATEWAY_SERVED_BY } from '@shared/constants/x-gateway-servedby';

const storeXGatewayServedBy = (xGatewayServedBy: Nullable<string>) => {
  if (!xGatewayServedBy || xGatewayServedBy === 'undefined') {
    return;
  }
  const cookie = new SingleValueCookie(X_GATEWAY_SERVED_BY);
  cookie.setValue(xGatewayServedBy);
  cookie.store(1, { path: '/' });
};

const getXGatewayServedBy = () => {
  const cookie = new SingleValueCookie(X_GATEWAY_SERVED_BY);
  return cookie.getValue();
};

export { getXGatewayServedBy, storeXGatewayServedBy };
